import type { S3ServiceConfig } from "./s3-static-upload.service";
import jwt_decode from "jwt-decode";
import { createPanchangamConfigService } from "./panchangam-config.service";
import { createPanchangamFileOpsService } from "./panchangam-file-ops.service";
import { createS3StaticUploadService } from "./s3-static-upload.service";

const YODA_CDN_URL = process.env.REACT_APP_NEW_CDN_URL || "https://srm-sbox-cdn.a4b.io";
const YODA_PRESIGN_URL = `${process.env.REACT_APP_CARNAGE_API_URL || ""}/yoda/internal/v1/generate-s3-presigned-url?filename=`;

const getAuthHeaders = (): Record<string, string> => {
    const token = JSON.parse(localStorage.getItem("userinfo") || "{}")?.access_token;

    const headers: Record<string, string> = {
        "x-afb-app-ver": "1.0.0",
        "x-afb-device-id": window.navigator.userAgent,
        "x-afb-platform": "web",
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const jwtRes: { sub?: string } = token ? jwt_decode(token) : {};
    if (jwtRes.sub) {
        headers["X-AFB-R-UID"] = jwtRes.sub;
    }

    return headers;
};

// ─── Service config ───────────────────────────────────────────────────────────
// When dropping this folder into a new CMS, only update this file:
// replace YODA_CDN_URL / YODA_PRESIGN_URL with the target project's constants,
// and update getAuthHeaders to match that project's conventions.

export const serviceConfig: S3ServiceConfig = {
    cdnUrl: YODA_CDN_URL,
    presignBaseUrl: YODA_PRESIGN_URL,
    getAuthHeaders,
};

// ─── Service instances ────────────────────────────────────────────────────────

export const panchangamConfigService = createPanchangamConfigService(serviceConfig);
export const s3StaticUploadService = createS3StaticUploadService(serviceConfig);
export const panchangamFileOpsService = createPanchangamFileOpsService(
    panchangamConfigService,
    s3StaticUploadService,
);
